/**
 * Text style types for form sections and fields
 */
export enum TextStyleType {
  Normal = 'normal',
  Bold = 'bold',
  Italic = 'italic',
  Underline = 'underline',
  BoldItalic = 'bold-italic'
}

